import { render, staticRenderFns } from "./OldReceipt.vue?vue&type=template&id=1f85c2d4&scoped=true&"
import script from "./OldReceipt.vue?vue&type=script&lang=js&"
export * from "./OldReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f85c2d4",
  null
  
)

export default component.exports